"use client";

import React, { useState, ReactNode } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDown, ChevronUp } from "lucide-react";
import "./SlideToggleSection.css";

interface SlideToggleSectionProps {
  title: string;
  children: ReactNode;
  initiallyOpen?: boolean;
  toggleLabel?: string;
  className?: string;
  hasError?: boolean;
}

export default function SlideToggleSection({
  title,
  children,
  initiallyOpen = false,
  toggleLabel = "Edit",
  className = "",
  hasError = false,
}: SlideToggleSectionProps) {
  const [isOpen, setIsOpen] = useState(initiallyOpen);

  const toggle = () => setIsOpen((prev) => !prev);

  return (
    <div
      className={`slide-toggle-wrapper ${className} 
        ${isOpen ? "is-focused" : ""} 
        ${hasError ? "has-error" : ""}
      `}
    >
      <div className="slide-toggle-header">
        <h4 className="slide-toggle-title">{title}</h4>
        <button onClick={toggle} className="slide-toggle-button">
          {toggleLabel}
          {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
        </button>
      </div>

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            key="content"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="slide-toggle-content"
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
